import React from 'react';
import TechnologiesSwitcher from '../../../../components/technologies.component';

export const HomeContentEduarea = props => (
  <div className='check-list-item'>
    <div className='check-list-item-progress'>
      <div className='check-list-item-index'>
      </div>
      <div className='check-list-item-sep'>
      </div>
    </div>
    <div className='check-list-item-body'>
      <p className='title'>
        <b>EduArea LLC</b> <span><span className='no-mobile'>/ </span>Mar 2013 – May 2018</span>
      </p>
      <TechnologiesSwitcher>
        <div>
          <p><b>Chief technology officer</b></p>
          <p>I was an software architect of some projects.</p>
          <p>I was responsible for designing and implementing software.</p>

          <p>I designed and implemented search using ElasticSearch and Lucene Engine, systems for distributed calculations, subsystems for statistics gathering and displaying.</p>
          <p>I designed full-stack architecture for proprietary Rich Internet Application (RIA) platform, designed full-stack architecture for cryptocurrency wallet with SPA (Single Page Application) client, managed and mentored junior developers, implemented designs for web applications.</p>

          <p>I analysed, designed and implemented web application for fitness using Scrum based project management.</p>
          <p>I analysed, designed and implemented of web services for managing and restarting applications, gathering statistics of usage.</p>

          <p>I improved knowledge of database design for relational and document-oriented databases.</p>
          <p>I improved configuring Unix/Linux systems and its administration, web services administration.</p>

          <p>I advised customers regarding maintenance of software system, software functionality.</p>
          <p>I integrated third-party systems with online payment processing and reporting subsystem.</p>

          <p>As a software architect I upgraded analysis, design and implement of working processes of the universities.</p>
          <p>As a software architect I analysed, designed and implemented recruiting center for immigrants.</p>

          <p>Work involves database design for relational and document-oriented databases, design and implement SPAs (single page applications).</p>
          <p>I took part at open source projects.</p>
        </div>
        <div>
          <p><b>Chief technology officer</b></p>
          <div className='project-list'>
            <div className='project-list-item'>
              <div className='project-list-title'>General technologies</div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Databases: PostreSQL, MongoDB.</div>
                <div>Web applications, HTML (for dynamic pages: freemarker or jade), XML, CSS (css, less, styl, scss), client side JavaScript (JQuery, AngularJS, React.js).</div>
                <div>Server-side JavaScript: Node.js, Express.</div>
                <div>Take part at <a
                  href='https://www.npmjs.com/package/rho'
                  target='_blank'
                  rel='noopener noreferrer'>rho</a>: a clone of markeven in JavaScript – text to html markup language, and <a
                  href='https://www.npmjs.com/package/bigfoot'
                  target='_blank'
                  rel='noopener noreferrer'>bigfoot</a>: client-server express based application framework.
                </div>
                <div>VCS (git)</div>
                <div>Build managers: maven - for Scala, npm - Node.js.</div>
                <div>Job scheduling using <a
                  href='http://www.quartz-scheduler.org/'
                  target='_blank'
                  rel='noopener noreferrer'>Quartz</a>.
                </div>
                <div>Document indexing and quick search via index document with lucene or ElasticSearch.</div>
                <div>Using quick key-value storages like Redis.</div>
                <div>Unix/Linux administration.</div>
                <div>Nginx as front end.</div>
                <div>Integrated third-party systems with online payment processing and reporting subsystem.</div>
                <div>Docker</div>
                <div>Cryptocurrencies (Ethereum, bitcoin and bitcoin-like altcoins)</div>
                <div>Smart Contracts for Ethereum</div>
              </div>
            </div>
            <div className='project-list-item'>
              <div className='project-list-title'>
                <a href='https://artfit.club/'
                   target='_blank'
                   rel='noopener noreferrer'>ArtFit Club</a>
              </div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Node.js</div>
                <div>MongoDB</div>
                <div>Redis</div>
                <div>Nginx</div>
                <div>Social network integrations</div>
                <div>Angular 1.5</div>
              </div>
            </div>
            <div className='project-list-item'>
              <div className='project-list-title'>
                <a href='https://eduterra.pro/'
                   target='_blank'
                   rel='noopener noreferrer'>EduTerra.pro</a>
              </div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Node.js</div>
                <div>MongoDB</div>
                <div>Redis</div>
                <div>ElasticSearch</div>
                <div>Nginx</div>
                <div>PayPal recurring billing</div>
                <div>EPUB 3.0.1</div>
              </div>
            </div>
            <div className='project-list-item'>
              <div className='project-list-title'>
                <a href='https://my.rfei.ru/'
                   target='_blank'
                   rel='noopener noreferrer'>my.rfei.ru</a>
              </div>
              <div
                className='project-list-description'>
                <span>management and educational platform for </span>
                <a href='https://rfei.ru/'
                   target='_blank'
                   rel='noopener noreferrer'>RFEI</a></div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Node.js</div>
                <div>MongoDB</div>
                <div>Redis</div>
              </div>
            </div>
            <div className='project-list-item'>
              <div className='project-list-title'>
                <a href='https://ru.savant.pro/'
                   target='_blank'
                   rel='noopener noreferrer'>SAVANT.PRO</a>
              </div>
              <div
                className='project-list-description'>educational platform for universities, including course development for universities (an ancestor of eduterra.pro)
              </div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Scala</div>
                <div>Quartz</div>
                <div>PostgreSQL</div>
                <div>Redis</div>
              </div>
            </div>
            <div className='project-list-item'>
              <div className='project-list-title'>profasia.org</div>
              <div
                className='project-list-description'>recruiting project helping people to find a job. It is oriented to immigrants to Russia (currently this project is closed by customer)
              </div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Scala</div>
                <div>PostgreSQL</div>
                <div>Redis</div>
              </div>
            </div>
            <div className='project-list-item'>
              <div className='project-list-title'>
                <a href='http://circumflex.ru/'
                   target='_blank'
                   rel='noopener noreferrer'>Circumflex</a>
              </div>
              <div
                className='project-list-description'>application framework for quick and robust application development using Scala programming language
              </div>
              <div
                className='project-list-technologies project-list-technologies--inline'>
                <div>Scala</div>
                <div>Databases</div>
                <div>FreeMarker</div>
              </div>
            </div>
          </div>
        </div>
      </TechnologiesSwitcher>
    </div>
  </div>
);
